// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3770": "beb0ab12","4218": "3b72774c","516": "5c0fcb8e",}[chunkId] + ".css"
}